import { setValidation } from 'js/vuex/actions';

export default {
    props: {
        partial: {},
        readonly: {
            type: Boolean,
            default: false,
        }
    },
    vuex: {
        actions: {
            setValidation
        }
    },

    created: function() {
        if ( ! this.readonly ) {
            this.setValidation(this.partial.id, true);
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/assignment/partials/autoValidateMixin.js